import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-seller-product-page',
  templateUrl: './seller-product-page.component.html',
  styleUrl: './seller-product-page.component.scss'
})
export class SellerProductPageComponent {
  sellerId: any;
  venderDetails: any;
  venderproduct: any;
  vendorProductImageUrl = environment.ImageBaseUrl;
  sellerStoreReviews: any[] | null = null;
  sellerStoreDetails: any;
  sellerAvgRating: any = { averageRating: 0 };
  sellerProducts: any;
  sellerReviews: any;

  constructor(private api:ApiServiceService , private activeRouter:ActivatedRoute , private router:Router){}
  
  ngOnInit(){
    this.activeRouter.params.subscribe((vendor :any)=>{
      this.sellerId = vendor['id'];
      if (!this.sellerId) return;

      this.getSellerStoreDetails();
      this.getSellerReviews();
      this.getSellerAvgRating();
      this.getSellerPopularProducts();
    })
  }

  getSellerStoreDetails(){
    this.api.getSellerStoreDetails(this.sellerId).subscribe((details: any)=>{
      this.sellerStoreDetails = details?.storeDetails;
    })
  }
  getSellerReviews(){
    this.api.getSellerReviews(this.sellerId).subscribe((review: any)=>{
      this.sellerStoreReviews = review?.reviews || [];
      this.sellerReviews = review?.rating;
    })
  }
  getSellerAvgRating(){
    this.api.getSellerAvgRating(this.sellerId).subscribe((rating: any)=>{
      this.sellerAvgRating = rating;
    })
  }

getSellerPopularProducts(){
    this.api.GetPopularProductsBySeller(this.sellerId).subscribe((product: any)=>{
      this.sellerProducts = product.data;
    })
  }
 
sellerAllProduct(sellerId : any){
  this.router.navigate(["seller-all-products" ,sellerId]);

}


  





 
}
